<template>
  <section class="swiper band highlight">
    <div
      v-if="!isLoading"
      class="background"
      aria-hidden="true"
      :style="`background-image: url('${blurImage}')`"
    >
      강조형 밴드 배경 이미지 영역
    </div>
    <div class="foreground">
      <div class="band-title-wrap">
        <h1 class="text-title">
          <span tabindex="0" class="band-title" v-if="hasMainTitleA">{{ mainTitleA }}</span>
          <span tabindex="0" class="band-title" v-if="hasMainTitleB">{{ mainTitleB }}</span>
        </h1>

        <p tabindex="0" class="band-subtitle" v-if="hasSubTitle" v-html="subTitle"></p>

        <a href="#" class="link-band-list" @click.prevent="goDetail">{{ cta }}</a>
      </div>

      <ul class="swiper-wrapper portrait" v-if="cellList.length > 0">
        <PortraitCell
          v-for="(cellInfo, index) in cellList"
          :cell-info="cellInfo"
          :cell-index="index"
          :thumbnail-info="thumbnailInfo"
          :key="index"
        />
      </ul>
    </div>
  </section>
</template>

<script setup>
  import { ref, defineProps, computed, onMounted } from 'vue'
  import { convertBand } from '@/common/converter/convert-band'
  import { getCellType } from '@/common/converter/utils/get-cell-type'
  import { getBandTypeInfoByCellType } from '@/common/image.util'
  import { routeToList } from '@/common/util/common'
  import { useRoute } from 'vue-router/composables'
  import { resizeThumbnail } from '@/common/image.filter'
  import PortraitCell from '@/components/section/template/cell/PortraitCell'

  const props =  defineProps({
    catalogInfo: {
      type: Object,
      default: () => {}
    },
    sectionInfo: {
      type: Object,
      default: null
    },
    multisectionIndex: {
      type: Number,
      default: 0
    }
  })

  const route = useRoute()

  const isLoading = ref(false)
  const band = ref({})
  const cellList = ref([])
  const cellTopList = ref({})
  const cta = ref('더보기')
  const blurImage = ref('')
  const titleList = ref([])
  const mainTitleA = ref('')
  const mainTitleB = ref('')
  const subTitle = ref('')

  const cellType = computed(() => getCellType(props.catalogInfo?.elementList))
  const thumbnailInfo = computed(() => getBandTypeInfoByCellType(cellType.value))
  const hasMainTitleA = computed(() => mainTitleA.value !== '')
  const hasMainTitleB = computed(() => mainTitleB.value !== '')
  const hasSubTitle = computed(() => subTitle.value !== '')

  const goDetail = () => routeToList(props.sectionInfo, route)

  const setBlurImage = (image) => {
    const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
    const portrait = window.matchMedia('(orientation: portrait)').matches
    if (w >= 768 && w <= 1366) {
      if (portrait) {
        blurImage.value = resizeThumbnail(image, { width: 1000, height: 340, option: 'b20', quality: 100 })
      } else {
        blurImage.value = resizeThumbnail(image, { width: 1342, height: 371, option: 'b20', quality: 100 })
      }
    } else {
      blurImage.value = resizeThumbnail(image, { width: 390, height: 432, option: 'b20', quality: 100 })
    }
  }

  const setTitle = (titleList) => {
    const [ titleA, titleB, titleSub ] = titleList.map(title => title?.text)
    mainTitleA.value = titleA ?? ''
    mainTitleB.value = titleB ?? ''
    subTitle.value = titleSub?.replaceAll('\n', '<br>') ?? ''
  }

  const setData = async () => {
    isLoading.value = true
    try {
      band.value = await convertBand(props.catalogInfo)
      cellList.value = band.value?.band?.celllist ?? []
      cellTopList.value = band.value?.cell_toplist ?? {}
      cta.value = cellTopList.value?.cta ?? '더보기'
      titleList.value = cellTopList.value?.title_list ?? []

      setBlurImage(cellTopList.value?.blurtarget_img ?? '')
      setTitle(titleList.value)

    } catch (error) {
      console.error(`Error in Highlight Catalog Band with ${error.message}`)
    } finally {
      isLoading.value = false
    }
  }

  setData()
</script>
